import { render, staticRenderFns } from "./loginLog.vue?vue&type=template&id=96790f30&"
import script from "./loginLog.vue?vue&type=script&lang=js&"
export * from "./loginLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports